import React from 'react';
import { useTranslation } from 'react-i18next';
import { branding } from '@/config/branding';
import './bootSpinner.css';

interface BootSpinnerProps {
    size?: 'small' | 'default' | 'large';
    message?: React.ReactNode;
}

const SIZE_CLASSES: Record<'small' | 'default' | 'large', string> = {
    small: 'text-[14px]',
    default: 'text-[20px]',
    large: 'text-[32px]',
};

const BootSpinner: React.FC<BootSpinnerProps> = ({ size = 'default', message }) => {
    const { t } = useTranslation('common');

    let content = message;
    if (content === undefined) {
        const msgKey = branding.loading.messageI18nKey;
        content = branding.loading.bilingualInline ? (
            <>
                {t(msgKey, { lng: 'en' })} &middot; <span lang="zh-CN">{t(msgKey, { lng: 'zh-CN' })}</span>
            </>
        ) : (
            t(msgKey)
        );
    }

    return (
        <>
            <span className={`boot-spin-dot text-primary dark:text-[#007ACC] ${SIZE_CLASSES[size]}`}
                role="status" aria-label="Loading">
                <span className="boot-spin-dot-holder">
                    <span className="boot-spin-dot-spin">
                        <i className="boot-spin-dot-item"></i>
                        <i className="boot-spin-dot-item"></i>
                        <i className="boot-spin-dot-item"></i>
                        <i className="boot-spin-dot-item"></i>
                    </span>
                </span>
            </span>
            {content !== undefined && (
                <p className="mt-2 text-sm text-center">{content}</p>
            )}
        </>
    );
};

export default BootSpinner;